import "../Styles/Web.css"
import { WebHeader } from "../components/organism/WebHeader";
import { WebFooter } from "../components/organism/WebFooter";
import { WebContact } from "../components/organism/WebContact";
import { WebReviews } from "../components/organism/WebReviews";
import { WebImages } from "../components/organism/WebImages";
import React, { useEffect, useState } from "react";
import CookieConsent, { Cookies, getCookieConsentValue as getCookies } from "react-cookie-consent";
import { WebPosts } from "../components/organism/WebPosts";
import { useFetch } from "../hooks/useFetch/useFetch";
import { useParams } from 'react-router-dom';
import { authRequest } from "../common/request/authRequest";
import { WebDescription } from "../components/organism/WebDescription";

export const Web = () => {

    let { id } = useParams();

    const [interiorImages, setInteriorImages] = useState([]);
    const [exteriorImages, setExteriorImages] = useState([]);    
    const [atWorkImages, setAtWorkImages] = useState([]);
    const [logo, setLogo] = useState([]);
    const [portada, setPortada] = useState([]);
    const [location, setLocation] = useState([]);
    
    useEffect(() => {
        
        authRequest(`${process.env.REACT_APP_API}/web/location?key=${id}`, {})
            .then((location) => {
                setLocation(location);
            })     
    }, []);

    useEffect(() => {
        
        authRequest(`${process.env.REACT_APP_API}/web/mediaItems?key=${id}`, {})
            .then((data) => {                
                setLogo(data?.logo?.googleUrl);
                setPortada(data?.portada?.googleUrl);
                setPortada(data?.portada?.googleUrl);
                setInteriorImages(data?.list?.filter((mediaItem) => mediaItem.category === 'INTERIOR'));
                setExteriorImages(data?.list?.filter((mediaItem) => mediaItem.category === 'EXTERIOR'));                
                setAtWorkImages(data?.list?.filter((mediaItem) => mediaItem.category === 'AT_WORK'));
            })        
        }, []);

    const { data, isLoading } = useFetch(
        `${process.env.REACT_APP_API}/web/config?key=${id}`,
        {},
        [],
    );  

    var webBlocks = data?.blocks;

    return (
        <div className="content-web">            
            <div>
                {webBlocks && webBlocks['HEADER'] && <WebHeader color={data?.color} logo={logo} portada={portada} location={location}/>}
                
                {webBlocks && webBlocks['DESCRIPTION'] && <WebDescription title='¿Qué ofrecemos?' color={data?.color} location={location}/>}
                {webBlocks && webBlocks['INTERIOR'] && interiorImages?.length > 0 && <WebImages text={webBlocks['INTERIOR'].text} images={interiorImages} title='El local' left={true} color={data?.color}/>}                
                {webBlocks && webBlocks['EXTERIOR'] && exteriorImages?.length > 0 && <WebImages text={webBlocks['EXTERIOR'].text} images={exteriorImages} title='Exteriores' left={false} color={data?.color}/> }
                {webBlocks && webBlocks['AT_WORK'] && atWorkImages?.length > 0 && <WebImages text={webBlocks['AT_WORK'].text} images={atWorkImages} title='El equipo' left={true} color={data?.color}/>}                
                {webBlocks && webBlocks['REVIEWS'] && <WebReviews title='Clientes' id={id} color={data?.color}/>}                
                {webBlocks && <WebPosts title='Noticias' id={id} color={data?.color}/>}
                {webBlocks && webBlocks['MAP'] && <WebContact title='Contacto' map={webBlocks['MAP'].active} location={location} logo={logo} color={data?.color}/>}

                {webBlocks && webBlocks['FOOTER'] && <WebFooter logo={logo} color={data?.color}/>}              
            </div>

            {/*<CookieConsent
                location="bottom"
                buttonText="Aceptar"
                cookieName="custom_cookies"
                style={{ background: "#2B373B" }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}

                onAccept={() => {
                console.log('Cookies aceptadas');
                // Agregar lógica adicional aquí
              }}
            >Este sitio web utiliza cookies para mejorar la experiencia del usuario.</CookieConsent>*/}
            
        </div>
    )
}